import ROUTE_NAME from "@/router/router.const";

export default {
  path: "/login_by_token/:refreshToken",
  name: ROUTE_NAME.LOGIN_BY_TOKEN,
  component: () => import("@/modules/stuff/LoginByToken.page"),
};
